'use strict';

// utility class
import ApplyClass from '../Utils/ApplyClass';
import Common from '../Utils/Common';
import Basic from '../Controller/Basic';

import ControlWelcomeMessage from '../View/Basic/ControlWelcomeMessage';
import SmoothScroll from '../View/Basic/SmoothScroll';
import Drawer from '../View/Basic/Drawer';
import SpSearch from '../View/Basic/SpSearch';
import FooterAccordion from '../View/Basic/FooterAccordion';
import AnchorPopover from '../View/Basic/AnchorPopover';
import Swiper from '../View/Basic/Swiper';
import BreadCrumb from '../View/Basic/BreadCrumb';
import ChangeDisplayType from '../View/Basic/ChangeDisplayType';
import AnchorFavorite from '../View/Basic/AnchorFavorite';
import AnchorDeleteFavorite from '../View/Basic/AnchorDeleteFavorite';
import BtnFavorite from '../View/Basic/BtnFavorite';
import Modal from '../View/Basic/Modal';
import CategoryAccordion from '../View/Basic/CategoryAccordion';
import GetChildCategories from '../View/Basic/GetChildCategories';
import AnchorSearchCondition from '../View/Basic/AnchorSearchCondition';
import BtnAddCart from '../View/Basic/BtnAddCart';
import StockControl from '../View/Basic/StockControl';
import CurrentViewedItem from '../View/Basic/CurrentViewedItem';
import ChangeCartQuantity from '../View/Basic/ChangeCartQuantity';
import AnchorCartDelete from '../View/Basic/AnchorCartDelete';
import SelectSku from '../View/Basic/SelectSku';
import QuantitySynchronize from '../View/Basic/QuantitySynchronize';
import FixCartBox from '../View/Basic/FixCartBox';
import Tab from '../View/Basic/Tab';
import InputRadioFavoriteShop from '../View/Basic/InputRadioFavoriteShop';
import GetCity from '../View/Basic/GetCity';
import BtnApplyCoupon from '../View/Basic/BtnApplyCoupon';
import BtnApplySelectedCoupon from '../View/Basic/BtnApplySelectedCoupon';
import BtnApplyModalCoupon from '../View/Basic/BtnApplyModalCoupon';
import GetCardToken from '../View/Basic/GetCardToken';
import ShopSearch from '../View/Basic/ShopSearch';
import TopNav from '../View/Basic/TopNav';
import BtnShowMore from '../View/Basic/BtnShowMore';
import TabNav from '../View/Basic/TabNav';
import TopCategory from '../View/Basic/TopCategory';
import SetBlankShop from '../View/Basic/SetBlankShop';
import ShopSelect from '../View/Basic/ShopSelect';
import SetFavoriteShop from '../View/Basic/SetFavoriteShop';
import CreateFavoriteShop from '../View/Basic/CreateFavoriteShop';
import PurchaseRouteType from '../View/Basic/PurchaseRouteType';
import BtnSearch from '../View/Basic/BtnSearch';
import AnchorCancel from '../View/Basic/AnchorCancel';
import ChangeNewsCategory from '../View/Basic/ChangeNewsCategory';
import UndeliverableAreaError from '../View/Basic/UndeliverableAreaError';
import FooterCategory from '../View/Basic/FooterCategory';
import AddSearchParameters from '../View/Basic/AddSearchParameters';
import AddSearchParameters2 from '../View/Basic/AddSearchParameters2';
import ChangeItemDetailImage from '../View/Basic/ChangeItemDetailImage';
import NotReceivableShop from '../View/Basic/NotReceivableShop';
import DefaultErrorModal from '../View/Basic/DefaultErrorModal';
import ChangeGuideTitle from '../View/Basic/ChangeGuideTitle';
import SpreadTagWidth from '../View/Basic/SpreadTagWidth';
import AnchorFaqAccordion from '../View/Basic/AnchorFaqAccordion';
import OnlyMemberText from '../View/Basic/OnlyMemberText';
import ReviewAverage from '../View/Basic/ReviewAverage';

// GA4 設定
import GA4SelectItem from '../View/Basic/GA4SelectItem';
import GA4BeginCheckout from '../View/Basic/GA4BeginCheckout';
import BtnInvoice from '../View/Basic/BtnInvoice';
import BtnInvoiceDownload from '../View/Basic/BtnInvoiceDownload';

$(() => {
	const BasicController = new Basic();
	// デバイス、ブラウザ判定
	Common.addHtmlClass();
	// Welcomeメッセージコントロール
	$('.page-select-favorite-shop').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ControlWelcomeMessage, $e, [$e, BasicController]);
	});
	//スムーススクロール
	$('a[href^="#"]').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(SmoothScroll, $e, [$e, BasicController]);
	});
	// ドロワー開閉
	$('.btn--drawer').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(Drawer, $e, [$e, BasicController]);
	});
	// SP検索ボタン
	$('.anchor--search').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(SpSearch, $e, [$e, BasicController]);
	});
	// フッターアコーディオン
	$('.anchor--footer-accordion').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(FooterAccordion, $e, [$e, BasicController]);
	});
	// ポップオーバー
	$('.anchor--popover').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(AnchorPopover, $e, [$e, BasicController]);
	});
	// slider
	$('.slider').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(Swiper, $e, [$e, BasicController]);
	});
	// パン屑リスト
	$('.aside--breadcrumb ol').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(BreadCrumb, $e, [$e, BasicController]);
	});
	// 表示タイプ変更
	$('.btn--display-type').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ChangeDisplayType, $e, [$e, BasicController]);
	});
	// お気に入り登録・解除
	$('.anchor--favorite').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(AnchorFavorite, $e, [$e, BasicController]);
	});
	// お気に入り解除
	$('.anchor--delete-favorite').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(AnchorDeleteFavorite, $e, [$e, BasicController]);
	});
	// お気に入り登録・解除
	$('.btn--favorite').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(BtnFavorite, $e, [$e, BasicController]);
	});
	// モーダル
	$('[data-toggle=modal]').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(Modal, $e, [$e, BasicController]);
	});
	// カテゴリーアコーディオン
	$('.list--sp-category .list__item__link--accordion').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(CategoryAccordion, $e, [$e, BasicController]);
	});
	// 子カテゴリー取得
	$('.get-child-category').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(GetChildCategories, $e, [$e, BasicController]);
	});
	// 絞り込み条件削除
	$('.anchor--search-condition').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(AnchorSearchCondition, $e, [$e, BasicController]);
	});
	// カートに入れる
	$('.btn--add-cart').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(BtnAddCart, $e, [$e, BasicController]);
	});
	// 在庫調整
	$('.page-item-detail').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(StockControl, $e, [$e, BasicController]);
	});
	// 最近見た商品
	$('.swiper--current-viewed').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(CurrentViewedItem, $e, [$e, BasicController]);
	});
	// カート数量変更
	$('.block__item--cart-quantity .input-select__select').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ChangeCartQuantity, $e, [$e, BasicController]);
	});
	// カート商品削除
	$('.anchor--cart-delete').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(AnchorCartDelete, $e, [$e, BasicController]);
	});
	// SKU選択
	$('.select-sku').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(SelectSku, $e, [$e, BasicController]);
	});
	// 数量同期
	$('.page-item-detail .quantity').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(QuantitySynchronize, $e, [$e, BasicController]);
	});
	// 固定カートボックス
	$('.block--fix-cart-box').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(FixCartBox, $e, [$e, BasicController]);
	});
	// タグ
	$('[data-toggle=tab]').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(Tab, $e, [$e, BasicController]);
	});
	// お気に入り店舗選択
	$('.input-radio--favorite-shop').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(InputRadioFavoriteShop, $e, [$e, BasicController]);
	});
	// 市区町村取得
	$('.get-city').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(GetCity, $e, [$e, BasicController]);
	});
	// クーポン適用
	$('.btn--apply-coupon').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(BtnApplyCoupon, $e, [$e, BasicController]);
	});
	// 選択クーポン適用
	$('.btn--apply-selected-coupon').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(BtnApplySelectedCoupon, $e, [$e, BasicController]);
	});
	// モーダルクーポン選択
	$('#modal-coupon-select .block--coupon-box').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(BtnApplyModalCoupon, $e, [$e, BasicController]);
	});
	// カードトークン取得
	// 購入経路
	$('.page-order-confirm').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(GetCardToken, $e, [$e, BasicController]);
		ApplyClass.apply(PurchaseRouteType, $e, [$e, BasicController]);
	});
	$('.page-mypage-card-input').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(GetCardToken, $e, [$e, BasicController]);
	});
	// 店舗検索
	$('.btn--shop-search').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ShopSearch, $e, [$e, BasicController]);
	});
	// トップナビ
	$('.list--nav-top').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(TopNav, $e, [$e, BasicController]);
	});
	// もっと見る
	$('.btn--show-more').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(BtnShowMore, $e, [$e, BasicController]);
	});
	// タブナビ
	$('.tab__navs--top').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(TabNav, $e, [$e, BasicController]);
	});
	// トップカテゴリー
	$('.list--top-category').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(TopCategory, $e, [$e, BasicController]);
	});
	// 空店舗設定
	$('body').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(SetBlankShop, $e, [$e, BasicController]);
	});
	// お気に入り店舗選択
	$('.page-select-favorite-shop').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ShopSelect, $e, [$e, BasicController]);
	});
	// 会員登録お気に入り店舗設定
	$('.page-register-confirm').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(SetFavoriteShop, $e, [$e, BasicController]);
	});
	// お気に入り店舗DOM作成
	$('.page-receiving-shop').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(CreateFavoriteShop, $e, [$e, BasicController]);
	});
	// 検索ボタン
	$('#header .btn--search').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(BtnSearch, $e, [$e, BasicController]);
	});
	$('.page-error-404 .main .btn--search').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(BtnSearch, $e, [$e, BasicController]);
	});
	// キャンセルボタン
	$('.anchor--cancel').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(AnchorCancel, $e, [$e, BasicController]);
	});
	// 領収書発行ボタン
	$('.btn--invoice').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(BtnInvoice, $e, [$e, BasicController]);
	});
	// 領収書を発行するボタン
	$('#btn-invoice-download').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(BtnInvoiceDownload, $e, [$e, BasicController]);
	});
	// お知らせカテゴリー絞り込み
	$('#news-category').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ChangeNewsCategory, $e, [$e, BasicController]);
	});
	// 配送不可地域エラー
	$('body.page-order .undeliverableArea').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(UndeliverableAreaError, $e, [$e, BasicController]);
	});
	// フッターカテゴリー
	$('#footer .block--category-wrap').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(FooterCategory, $e, [$e, BasicController]);
	});
	// ソートパラメーター追加
	$('.btn--sort').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(AddSearchParameters, $e, [$e, BasicController]);
	});
	// ページパラメーター追加
	$('.pagination__item__link').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(AddSearchParameters2, $e, [$e, BasicController]);
	});
	// 受取店舗不可エラー表示
	$('#not_receivable_shop').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(NotReceivableShop, $e, [$e, BasicController]);
	});
	// メイン画像変更
	$('.image-box--thumb .image').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ChangeItemDetailImage, $e, [$e, BasicController]);
	});
	// デフォルトエラーモーダル
	$('#show-error-modal').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(DefaultErrorModal, $e, [$e, BasicController]);
	});
	// ガイドタイトル変更
	$('#guide-navigation').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ChangeGuideTitle, $e, [$e, BasicController]);
	});
	// タグ幅拡張
	$('.form-group__content--tag .input-checkbox').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(SpreadTagWidth, $e, [$e, BasicController]);
	});
	// FAQアコーディオン
	$('.anchor--pickup-question').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(AnchorFaqAccordion, $e, [$e, BasicController]);
	});
	// ご利用ガイドメンバー専用テキスト
	$('.only-member').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(OnlyMemberText, $e, [$e, BasicController]);
	});
	// レビュー平均点数調整
	$('.review-average').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ReviewAverage, $e, [$e, BasicController]);
	});

	/* GA4 設定 */
	// GA4 select_item
	$('.page-category .card--item .anchor:not(.anchor--favorite)').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(GA4SelectItem, $e, [$e, BasicController]);
	});
	$('.page-category .card--item .anchor--item-name').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(GA4SelectItem, $e, [$e, BasicController]);
	});
	$('.page-search .card--item .anchor:not(.anchor--favorite)').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(GA4SelectItem, $e, [$e, BasicController]);
	});
	$('.page-search .card--item .anchor--item-name').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(GA4SelectItem, $e, [$e, BasicController]);
	});
	// GA4 begin_checkout
	$('.btn--checkout').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(GA4BeginCheckout, $e, [$e, BasicController]);
	});
});
